import { useEffect, useRef, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import "./StyleMobile.css";
import Styles from "./Dashboard.module.css";
import { useDispatch } from "react-redux";
import { PredictedScoreData, TargetScoreData } from "../../Action/ScoreAction";
import { useSelector } from "react-redux";
import Slider from "react-slick";

import Styles2 from "../Home/Home.module.css";
import { FaCircleArrowLeft, FaCircleArrowRight } from "react-icons/fa6";
import PackageCard from "../../Components/PackageCard";
import { useNavigate } from "react-router-dom";
import Enroll from "../Home/Enroll";
// import { GET_SCORE_TEXT } from "../../Model/HomeModel";
import { Take_Test_Det } from "../../Action/TLastAction";
export default function MobileDashboard({ Login_User, TLatResult }) {
  const [SideOpener, setSideOpner] = useState(false);
  const [CourseId, setCourseId] = useState("");
  const [EnrollActive, setEnrollActive] = useState(false);
  const [ScoreType, setScoreType] = useState("p");
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  const [currentSlide, setCurrentSlide] = useState(0);
  const Navigate = useNavigate();
  const { laoding, error, PredictedScore } = useSelector(
    (s) => s.PredictedScoreDataReducer
  );
  const { loading: loadingPack, PackageRec } = useSelector(
    (s) => s.Package_List_Reducer
  );
  const BrowsePackageRef = useRef();
  const Mobile_Screen = window.innerWidth;

  const coordinators = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    afterChange: (current) => setCurrentSlide(current),
    slidesToShow: 2,
    slidesToScroll: 1,
  };
  const BrowsePacakgesettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    afterChange: (current) => setCurrentSlide(current),
    slidesToShow:
      Mobile_Screen <= 480
        ? 1
        : Mobile_Screen <= 780
        ? PackageRec?.length >= 2
          ? 2
          : 1
        : PackageRec?.length >= 2
        ? 2
        : PackageRec?.length == 2
        ? 2
        : 1,
    slidesToScroll: 1,
  };

  const getRotation = (index) => {
    const pos = index - currentSlide;
    if (pos === -2) return "rotate(-5deg)";
    if (pos === -1) return "rotate(-2.5deg)";
    if (pos === 0) return "rotate(0deg)";
    if (pos === 1) return "rotate(2.5deg)";
    if (pos === 2) return "rotate(5deg)";
    return "rotate(0deg)";
  };

  const {
    laoding: loadingT,
    error: errorT,
    TargetScore,
  } = useSelector((s) => s.TargetScoreDataReducer);

  const dispatch = useDispatch();

  function switchTab(e, tabId) {
    e.preventDefault();
    setScoreType(tabId);
  }

  useEffect(() => {
    dispatch(TargetScoreData());
    dispatch(PredictedScoreData());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Mobile_View_css">
      <div
        onClick={OpenSideMenu}
        className={SideOpener ? "menu-overlay active" : "menu-overlay"}
        id="menuOverlay"
      ></div>
      {EnrollActive ? (
        <Enroll
          setEnrollActive={setEnrollActive}
          Package_Id={EnrollActive}
          courseId={CourseId}
        />
      ) : (
        ""
      )}
      <MobileLeftSection SideOpener={SideOpener} Page="Dashboard" />

      <div className="main-content">
        <MobileHeaderSection Page="Dashboard" OpenSideMenu={OpenSideMenu} />
        <div className="page-content" id="dashboardPage">
          {/* <!-- Welcome Section --> */}
          <section className="welcome-section">
            <div className="" style={{ position: "relative" }}>
              <img src="/TESTIFYI_BANNER.png" style={{ width: "100%" }} />
              <div>
                <div>
                  <div style={{ position: "absolute", left: "4%", top: "35%" }}>
                    <p style={{ color: "white" }}>
                      Hi{" "}
                      {Login_User?.First_Name
                        ? Login_User?.First_Name + " " + Login_User?.Last_Name
                        : ""}{" "}
                      !
                    </p>
                  </div>
                  <div
                    className="banner-right"
                    style={{
                      position: "absolute",
                      right: "0%",
                      top: 0,
                      height: "130px",
                      width: "130px",
                    }}
                  >
                    <dotlottie-player
                      src="https://lottie.host/f8086c29-0b96-4ab8-bd40-c66ac5511949/n1y89JuvjU.lottie"
                      background="transparent"
                      speed="1"
                      loop
                      autoplay
                    ></dotlottie-player>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <!-- Course Progress --> */}
          <section className="course-progress">
            {TLatResult || TLatResult == 0 ? (
              <div className="Result_Check">
                <div
                  className="progress-card"
                  style={{
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    className={Styles.ScoreDetails}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      padding: "0",
                      margin: "0",
                    }}
                  >
                    <div
                      style={{ padding: "0", marginLeft: "-45px" }}
                      className={Styles.circle_container}
                    >
                      <svg width="90" height="90">
                        <circle
                          className={Styles.bg_circle}
                          cx="45"
                          cy="45"
                          r="30"
                        ></circle>
                        <circle
                          className={Styles.progress}
                          cx="45"
                          cy="45"
                          r="30"
                          id="progressCircle"
                        ></circle>
                      </svg>
                      <div className={Styles.score_text}>
                        <span
                          className={Styles.score}
                          style={{ fontSize: "14px" }}
                        >
                          {TLatResult}
                        </span>
                        <span
                          className={Styles.out_of}
                          style={{ fontSize: "14px" }}
                        >
                          /60
                        </span>
                      </div>
                    </div>
                    <div
                      className="progress-info"
                      style={{
                        fontSize: "11px",
                        color: "black",
                        width: "240px",
                        marginLeft: "-50px",
                      }}
                    >
                      <p style={{ color: "black" }}>
                        TLAT(Testify Language Assessment)
                      </p>
                      {/* <p style={{ textAlign: "center" }}>
                        {GET_SCORE_TEXT(TLatResult)}
                      </p> */}
                      <button
                        onClick={() => Navigate("/T-LAT-answers")}
                        className="check-button"
                      >
                        Check Result
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="progress-card Result_Check"
                style={{ padding: "20px 10px" }}
              >
                <div className="progress-header">
                  {/* <div className="progress-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                    </svg>
                  </div> */}
                  <div className="progress-info">
                    <span
                      className="progress-count"
                      style={{ fontSize: "10px" }}
                    >
                      TLAT(Testify Language Assessment)
                    </span>
                    <h3 style={{ fontSize: "12px" }}>
                      Are You Ready to Ace IELTS/PTE?
                    </h3>
                  </div>
                  <button
                    style={{ textAlign: "center" }}
                    onClick={() =>
                      dispatch(
                        Take_Test_Det({
                          EmailAddress: Login_User?.EmailAddress,
                        })
                      )
                    }
                    className="check-button"
                  >
                    Start Free T-LAT
                    <br /> Test Now
                  </button>
                </div>
              </div>
            )}
          </section>

          {/* <!-- Skills Table --> */}
          <section className="skills-section">
            <div className="skills-table">
              <div className="table-header">
                <div
                  onClick={(e) => switchTab(e, "p")}
                  className={
                    ScoreType == "p"
                      ? "header-cell predicted active"
                      : "header-cell predicted "
                  }
                >
                  <i className="fas fa-chart-line"></i> Predicted
                </div>
                <div
                  onClick={(e) => switchTab(e, "t")}
                  className={
                    ScoreType == "t"
                      ? "header-cell predicted active"
                      : "header-cell target "
                  }
                >
                  <i className="fas fa-bullseye"></i> Target
                </div>
              </div>
              {ScoreType == "p" ? (
                <div className="table-body">
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-pen"></i> Writing
                    </div>
                    <div className="score-cell">
                      {PredictedScore?.Writing?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-book-open"></i> Reading
                    </div>
                    <div className="score-cell">
                      {PredictedScore?.Reading?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-microphone"></i> Speaking
                    </div>
                    <div className="score-cell">
                      {PredictedScore?.Speaking?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-headphones"></i> Listening
                    </div>
                    <div className="score-cell">
                      {PredictedScore?.Listening?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-star"></i> Overall
                    </div>
                    <div className="score-cell">
                      {PredictedScore?.Overall?.$numberDecimal || 0}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="table-body">
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-pen"></i> Writing
                    </div>
                    <div className="score-cell">
                      {TargetScore?.Writing?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-book-open"></i> Reading
                    </div>
                    <div className="score-cell">
                      {TargetScore?.Reading?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-microphone"></i> Speaking
                    </div>
                    <div className="score-cell">
                      {TargetScore?.Speaking?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-headphones"></i> Listening
                    </div>
                    <div className="score-cell">
                      {TargetScore?.Listening?.$numberDecimal || 0}
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="skill-cell">
                      {" "}
                      <i className="fas fa-star"></i> Overall
                    </div>
                    <div className="score-cell">
                      {TargetScore?.Overall?.$numberDecimal || 0}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* <!-- Course Cards Horizontal Scroll --> */}
          {/* <section className="course-cards-section">
            <div className="course-cards-scroll" id="courseCardsScroll">
              <div className="course-card-new">
                <div className="course-image">
                  <img
                    src="https://images.pexels.com/photos/5427674/pexels-photo-5427674.jpeg?auto=compress&cs=tinysrgb&w=400&h=250&fit=crop"
                    alt="Students studying"
                  />
                  <div className="course-badge star">Star</div>
                  <div className="course-duration">5 Weeks</div>
                </div>
                <div className="course-content">
                  <h3>IELTS General Course - CBT 02</h3>
                  <div className="course-features">
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polygon points="23 7 16 12 23 17 23 7" />
                        <rect
                          x="1"
                          y="5"
                          width="15"
                          height="14"
                          rx="2"
                          ry="2"
                        />
                      </svg>
                      <span>25 Live Classes</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                        <path d="M12 17h.01" />
                      </svg>
                      <span>Doubt Sessions</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M3 3v18h18" />
                        <path d="M18.7 8a3 3 0 0 0-5.4 0" />
                        <path d="M13.3 16a3 3 0 0 0 5.4 0" />
                      </svg>
                      <span>Session Tests</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                      </svg>
                      <span>Study Material</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M12 8V4H8" />
                        <rect width="16" height="12" x="4" y="8" rx="2" />
                        <path d="M2 14h2" />
                        <path d="M20 14h2" />
                        <path d="M15 13v2" />
                        <path d="M9 13v2" />
                      </svg>
                      <span>3 AI Mock Test</span>
                    </div>
                  </div>
                  <div className="course-price">₹9,999/-</div>
                  <div className="course-actions">
                    <button className="btn-outline">View</button>
                    <button className="btn-primary">Enroll Now</button>
                  </div>
                </div>
              </div>

              <div className="course-card-new">
                <div className="course-image">
                  <img
                    src="https://images.pexels.com/photos/5212317/pexels-photo-5212317.jpeg?auto=compress&cs=tinysrgb&w=400&h=250&fit=crop"
                    alt="Online learning"
                  />
                  <div className="course-badge premium">Premium</div>
                  <div className="course-duration">8 Weeks</div>
                </div>
                <div className="course-content">
                  <h3>IELTS Academic Course - PBT</h3>
                  <div className="course-features">
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polygon points="23 7 16 12 23 17 23 7" />
                        <rect
                          x="1"
                          y="5"
                          width="15"
                          height="14"
                          rx="2"
                          ry="2"
                        />
                      </svg>
                      <span>30 Live Classes</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                        <path d="M12 17h.01" />
                      </svg>
                      <span>Doubt Sessions</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M3 3v18h18" />
                        <path d="M18.7 8a3 3 0 0 0-5.4 0" />
                        <path d="M13.3 16a3 3 0 0 0 5.4 0" />
                      </svg>
                      <span>Session Tests</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                      </svg>
                      <span>Study Material</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M12 8V4H8" />
                        <rect width="16" height="12" x="4" y="8" rx="2" />
                        <path d="M2 14h2" />
                        <path d="M20 14h2" />
                        <path d="M15 13v2" />
                        <path d="M9 13v2" />
                      </svg>
                      <span>5 AI Mock Test</span>
                    </div>
                  </div>
                  <div className="course-price">₹12,999/-</div>
                  <div className="course-actions">
                    <button className="btn-outline">View</button>
                    <button className="btn-primary">Enroll Now</button>
                  </div>
                </div>
              </div>

              <div className="course-card-new">
                <div className="course-image">
                  <img
                    src="https://images.pexels.com/photos/4145190/pexels-photo-4145190.jpeg?auto=compress&cs=tinysrgb&w=400&h=250&fit=crop"
                    alt="Study group"
                  />
                  <div className="course-badge new">New</div>
                  <div className="course-duration">6 Weeks</div>
                </div>
                <div className="course-content">
                  <h3>TOEFL Preparation Course</h3>
                  <div className="course-features">
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polygon points="23 7 16 12 23 17 23 7" />
                        <rect
                          x="1"
                          y="5"
                          width="15"
                          height="14"
                          rx="2"
                          ry="2"
                        />
                      </svg>
                      <span>20 Live Classes</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                        <path d="M12 17h.01" />
                      </svg>
                      <span>Doubt Sessions</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M3 3v18h18" />
                        <path d="M18.7 8a3 3 0 0 0-5.4 0" />
                        <path d="M13.3 16a3 3 0 0 0 5.4 0" />
                      </svg>
                      <span>Session Tests</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                      </svg>
                      <span>Study Material</span>
                    </div>
                    <div className="feature">
                      <svg
                        className="feature-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M12 8V4H8" />
                        <rect width="16" height="12" x="4" y="8" rx="2" />
                        <path d="M2 14h2" />
                        <path d="M20 14h2" />
                        <path d="M15 13v2" />
                        <path d="M9 13v2" />
                      </svg>
                      <span>4 AI Mock Test</span>
                    </div>
                  </div>
                  <div className="course-price">₹8,999/-</div>
                  <div className="course-actions">
                    <button className="btn-outline">View</button>
                    <button className="btn-primary">Enroll Now</button>
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          <section style={{ background: "#f4f9ff", paddingBottom: "60px" }}>
            <div style={{ margin: "30px" }}>
              <div className={Styles.Browse_Package_Section}>
                <div>
                  {" "}
                  <h1 className={Styles.Heading}>
                    <span className="Font_Rajdhani">Browse Courses </span>
                  </h1>
                </div>
                <div className={Styles.Browse_Package_Scroller}>
                  <div onClick={() => BrowsePackageRef?.current?.slickPrev()}>
                    <FaCircleArrowLeft />
                  </div>
                  <div onClick={() => BrowsePackageRef?.current?.slickNext()}>
                    {" "}
                    <FaCircleArrowRight />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ margin: "0 20px" }}>
              <Slider
                ref={BrowsePackageRef}
                style={{ width: "100%" }}
                {...BrowsePacakgesettings}
              >
                {PackageRec?.map((el, index) => (
                  <div
                    key={index}
                    style={{
                      transform: getRotation(index),
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <PackageCard
                      setEnrollActive={setEnrollActive}
                      EnrollActive={EnrollActive}
                      setCourseId={setCourseId}
                      el={el}
                      Styles={Styles2}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </section>

          {/* <!--  className="coordinator-cards" --> */}
          <section className="coordinators Counsellor_mbl">
            <div className="coordinator-cards">
              {/* <Slider
                ref={BrowsePackageRef}
                style={{ width: "100%" }}
                {...coordinators}
              > */}
              <div className="contact-card" style={{ background: "#E0E6FF" }}>
                <img
                  src="/assets/image/Neha_Sagar.png"
                  alt="Profile"
                  className="profile-img"
                />
                <div className="contact-info">
                  <h3 className="name">Neha Sagar</h3>
                  <p className="role">Coordinator</p>
                  <p className="email">info@testifyi.com</p>
                  <p className="phone">+91 9310123737</p>
                </div>
              </div>

              <div className="contact-card" style={{ background: "#E5E0FF" }}>
                <img
                  src="/assets/image/Vivek_Sharma.png"
                  alt="Profile"
                  className="profile-img"
                />
                <div className="contact-info">
                  <h3 className="name">Vivek Sharma</h3>
                  <p className="role">Manager</p>
                  <p className="email">info@testifyi.com</p>
                  <p className="phone">+91 7982476900</p>
                </div>
              </div>
              {/* </Slider> */}
            </div>
          </section>
        </div>
        <MobileBottomMenu Page="Dashboard" />
      </div>
    </div>
  );
}
